import(/* webpackMode: "eager" */ "/vercel/path0/web/app/(main)/handboka/page.tsx");
